import { Download } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';

interface DownloadOrderInvoiceButtonProps {
  downloadLink: string;
}

const DownloadOrderInvoiceButton: React.FC<DownloadOrderInvoiceButtonProps> = ({
  downloadLink,
}) => {
  const { t } = useTranslation();
  return (
    <a href={downloadLink} target="_blank" rel="noreferrer" download>
      <Button variant="outline">
        <Download />
        <p className="p2-medium">
          {t('orderConfirmationPage.downloadInvoice')}
        </p>
      </Button>
    </a>
  );
};

export default DownloadOrderInvoiceButton;
